import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { from, Observable } from 'rxjs';

@Component({
  selector: 'app-lunch',
  templateUrl: './lunch.component.html',
  styleUrls: ['./lunch.component.css']
})
export class LunchComponent implements OnInit {
  returnJson: Observable<Response>;
  lunch: any;

  constructor(private httpService: HttpClient) {
    this.returnJson = this.httpService.post<any>('https://fatraceschool.moe.gov.tw/cateringservice/openapi/opendatadownload/', 
    {
      "accesscode": "420e815c2220200401205706",
      "year": "2019",
      "month": "03",
      "county": "澎湖縣",
      "grade": "國中小",
      "datasetname": "午餐菜色資料集"
      }
    );
    console.log(this.returnJson)
    this.returnJson.subscribe( data => {
      this.lunch = data;
      console.log(this.lunch)
    })
   }

  ngOnInit(): void {
    
   
    
  }

}
